/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// @flow
import React, { useState } from 'react';

import GroupTab from 'components/competitionsInternationales/CompetitionsInternationalesHomeOverGroupTab';
import PlayersTab from 'components/competitionsInternationales/CompetitionsInternationalesHomeOverPlayersTab';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import type { CompetitionInternationale } from 'types/competitionsInternationales';

type Props = {
  data: CompetitionInternationale
};

function CompetitionsInternationalesHomeOver({ data }: Props) {
  const [activeComponent, setActiveComponent] = useState('');

  const {
    content_competition_over: { bottom_page, competition_stats, players_stats, top_page }
  } = data;

  return (
    <>
      {!!top_page.data &&
        !!top_page.data.length &&
        top_page.data.map((bloc, index) => <ContentBloc key={index} {...bloc} />)}

      <nav className="single-match__nav">
        <ul>
          <li className={activeComponent === '' ? 'active' : ''} onClick={() => setActiveComponent('')}>
            <span>Le groupe</span>
          </li>
          <li
            className={activeComponent === 'player-tab' ? 'active' : ''}
            onClick={() => setActiveComponent('player-tab')}
          >
            <span>Les joueurs</span>
          </li>
        </ul>
      </nav>

      <section className="section section--match-over">
        {activeComponent === '' && <GroupTab competition_stats={competition_stats} />}

        {activeComponent === 'player-tab' && <PlayersTab players_stats={players_stats} />}
      </section>

      {!!bottom_page.data &&
        !!bottom_page.data.length &&
        bottom_page.data.map((bloc, index) => <ContentBloc key={index} {...bloc} />)}
    </>
  );
}

export default CompetitionsInternationalesHomeOver;
